import { Chip, Typography } from '@mui/material'
import { useMemo } from 'react'

import { DeliveryStatus } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

type DeliveryManagementTagProps = {
  status: DeliveryStatus
}
export const DeliveryManagementTag: Cell<DeliveryManagementTagProps> = ({
  status,
}) => {
  const { t } = useTranslation('consoleDeliveryManagement')
  const { bgcolor } = useMemo(() => {
    switch (status) {
      case DeliveryStatus.Arranging:
        return { bgcolor: 'primary.main' }
      case DeliveryStatus.Shipped:
        return { bgcolor: 'grey.200' }
      default:
        return { bgcolor: '' }
    }
  }, [status])
  return (
    <Chip
      size="small"
      sx={{
        height: 20,
        borderRadius: '2px',
        bgcolor,
        py: 1,
        '.MuiChip-label': { px: 1 },
      }}
      label={
        <Typography color="white" variant="overline">
          {t(status)}
        </Typography>
      }
    />
  )
}
